import { render, staticRenderFns } from "./embed-store.vue?vue&type=template&id=72c95f7a&scoped=true&"
import script from "./embed-store.vue?vue&type=script&lang=js&"
export * from "./embed-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c95f7a",
  null
  
)

export default component.exports